import { FormControl, RadioGroup, FormControlLabel, Radio, Box, Paper, Typography } from '@mui/material';

function ArtifactTypeSelector({ value = 'requirements', onChange }) {
  return (
    <Box sx={{ width: '100%', maxWidth: 900, mb: 3 }}>
      <Paper 
        elevation={1}
        sx={{ 
          p: 2,
          backgroundColor: 'slate_gray.main',
          border: '1px solid rgba(43, 85, 135, 0.2)',
        }}
      >
        <Box sx={{ 
          display: 'flex', 
          alignItems: 'center',
        }}>
          <Typography 
            variant="subtitle1" 
            component="div" 
            sx={{ 
              color: 'text.main',
              fontWeight: 500,
              mr: 3
            }}
          >
            Artifact Type:
          </Typography>
          <FormControl 
            required 
            sx={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <RadioGroup
              row
              aria-labelledby="artifact-type-label"
              name="artifact-type"
              value={value}
              onChange={onChange}
              defaultValue="requirements"
              sx={{
                gap: 6
              }}
            >
              {[
                { value: 'requirements', label: 'Requirements' },
                { value: 'assets', label: 'Assets' }
              ].map((option) => (
                <FormControlLabel
                  key={option.value}
                  value={option.value}
                  label={
                    <Typography 
                      variant="body2"
                      sx={{ 
                        color: 'text.main',
                        fontWeight: value === option.value ? 500 : 400,
                      }}
                    >
                      {option.label}
                    </Typography>
                  }
                  sx={{
                    margin: 0,
                    display: 'flex',
                    alignItems: 'center',
                    '& .MuiFormControlLabel-label': {
                      marginLeft: '8px',
                      marginRight: 0,
                    }
                  }}
                  control={
                    <Radio 
                      size="small"
                      disableRipple
                      sx={{
                        color: 'transparent',
                        '& .MuiSvgIcon-root': {
                          color: 'transparent',
                          border: '2px solid gold.main',
                          borderRadius: '50%'
                        },
                        '&.Mui-checked': {
                          color: 'gold.main',
                          '& .MuiSvgIcon-root': {
                            color: 'gold.main',
                            border: 'none'
                          }
                        }
                      }}
                    />
                  }
                />
              ))}
            </RadioGroup>
          </FormControl>
        </Box>
      </Paper>
    </Box>
  );
}

export default ArtifactTypeSelector; 